<template>
    <div>
        <el-dialog
            title="上传付款记录"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                    <div class="content a-flex-cfsfs">
                        <span class="a-fs-14 a-fw-700 a-c-333" >账单编号：{{ billInfo.id || '-' }}</span>
                        <span class="a-mt-10 a-fs-13">计费/抄表区间：{{ billInfo.billDateStart || '-' }} 至 {{ billInfo.billDate || '-' }}</span>
                        <div class="a-flex-rfec a-mt-10 a-fs-13">
                            <span>总应付：￥{{ util.numFormat(billInfo.totalPay || 0) }}</span>
                            <span class="a-ml-20">已付：￥{{ util.numFormat(billInfo.payAmount || 0) }}</span>
                            <span class="a-ml-20 a-c-error">剩余应付：￥{{ util.numFormat(billInfo.totalPay - billInfo.payAmount) }}</span>
                        </div>
                    </div>
                    <el-form-item label="本次付款" prop="amount">
                        <jd-input-price v-model="form.amount" :disabled="editType=='edit'?true:false"></jd-input-price>
                    </el-form-item>
                    <el-form-item label="付款时间" prop="payTime">
                        <el-date-picker
                            v-model="form.payTime"
                            value-format='yyyy-MM-dd HH:mm:ss'
                            type="datetime"
                            placeholder="选择付款时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="付款回单" prop="images">
                        <!-- <le-upload-file-img-ly multiple drag enablePaste ref="pic" v-model="form.images" :limit='10'></le-upload-file-img-ly> -->
                        <jd-file-upload
                            multiple
                            drag
                            :taxFiles.sync="form.images"
                            :max="10"
                            ref="pic"
                            accept=".pdf,.jpg,.jpeg,.png"
                            placeholder="支持拖拽、点击或粘贴上传"
                            enablePaste
                        />
                    </el-form-item>
                    <el-form-item label="付款备注" prop="remark">
                        <el-input
                            style="width: 400px;"
                            type="textarea"
                            :autosize="{ minRows: 4 }"
                            placeholder="请输入内容"
                            maxlength="200"
                            show-word-limit
                            v-model="form.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import jdFileUpload from '../../components/formcy/jd-file-upload.vue';
    export default {
        components: {
            jdFileUpload
        },
        data() {
            var checkAmount = (rule, value, callback) => {
                if(this.editType == 'edit') {
                    callback()
                }else if(this.form.amount === '0' || !this.form.amount){
                    callback(new Error('请输入付款金额'))
                }else if(Number((this.form.amount*100).toFixed(0)) > this.billInfo.totalPay - this.billInfo.payAmount) {
                    callback(new Error('超过当前剩余应付金额'))
                }else{
                    callback()
                }
            };
            return {
                util,
                dialogVisible: false,
                id: '',
                billInfo: '',
                editType: '',
                form: {
                    amount: '',
                    images: [],
                    payTime: '',
                    remark: ''
                },
                rules:{
                    amount: [{required: true, message:'请输入付款金额', trigger: 'blur'},{ validator: checkAmount, trigger: 'blur'}],
                    payTime: [{required: true, message:'请选择付款时间', trigger: 'change'}]
                },
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                    this.$refs['pic'].fileList = []
                }
            },
        },
        methods:{
            handleInitUpload () {
                this.$refs['pic'].fileList = this.form.images.map(item=>{
                    return {
                        name: item.split('/')[item.split('/').length - 1],
                        url: item
                    }
                })
            },
            submit () {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.$confirm('是否确认提交？','温馨提示')
                        .then(_=>{
                            let reqData = '', apiUrl = ''
                            if(this.editType == 'edit') {
                                apiUrl = this.$Config.apiUrl.updatePayRecord
                                reqData = {
                                    ...this.form,
                                    id: this.id,
                                    images: this.form.images && this.form.images.length ? JSON.stringify(this.form.images.map(item=>{return item.url})) : ''
                                }
                            }else {
                                apiUrl = this.$Config.apiUrl.electricBillPay
                                reqData = {
                                    ...this.form,
                                    amount: (this.form.amount * 100).toFixed(0),
                                    id: this.billInfo.id,
                                    images: this.form.images && this.form.images.length ? JSON.stringify(this.form.images.map(item=>{return item.url})) : ''
                                }
                            }
                            this.$Axios._post({
                                url: apiUrl,
                                params: { 
                                    ...reqData
                                }
                            }).then(res => {
                                this.$message.success('操作成功')
                                this.dialogVisible = false
                                this.$emit('change')
                            })
                        })
                        .catch(_=>{})
                        
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content{
        background: #F2F6FC99;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>